<div class="clug-page clients-page">
  <div class="page-head">
    <div class="title-block">
      <h1 class="page-title">Clients</h1>
      <p class="lede">Manage every client and their contacts.</p>
    </div>
    <div class="action-bar" *ngIf="user?.role_uuid === ROLES?.AGENCY">
      <button type="button" class="btn btn-primary" (click)="createClient()">
        <i class="bi bi-plus-lg"></i><span>Add Client</span>
      </button>
    </div>
  </div>

  <nav class="page-tabs">
    <a class="page-tab cursor-pointer" [class.active]="active_contact === 1" (click)="showCLientContact(1)">Active</a>
    <a class="page-tab cursor-pointer" [class.active]="active_contact === 0" (click)="showCLientContact(0)">Inactive</a>
  </nav>

  <div class="clug-list-card">
    <div class="card-loader" *ngIf="loading">
      <mat-spinner diameter="28"></mat-spinner>
    </div>

    <div class="card-header">
      <span class="card-header-count">{{totalCount}} Client(s)</span>
      <div class="input-group">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search clients..." [(ngModel)]="clientSearch" (keyup)="searchClient()">
      </div>
    </div>

    <div class="table-responsive">
      <table matSort (matSortChange)="sortData($event)" class="table">
        <thead>
          <tr>
            <th mat-sort-header="name" scope="col">Name</th>
            <th mat-sort-header="name" scope="col">Identifier</th>
            <th mat-sort-header="created_at" scope="col">Created At</th>
            <th scope="col">Contacts</th>
            <th scope="col" class="actions-col" *ngIf="user.role_uuid === ROLES.AGENCY && active_contact == 1">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let client of allClients" class="dataColumn">
            <td (click)="editClient(client)">
              <div class="contractor-cell">
                <div class="avatar"><span>{{authService.getInitials(client.name)}}</span></div>
                <span class="contractor-name">{{client.name}}</span>
              </div>
            </td>
            <td>{{client.identifier}}</td>
            <td>{{dataSharedService.getFormatedDate(client.created_at)}}</td>
            <td>
              <div class="avatar-group" (click)="viewClientsContacts(client)">
                <ng-container *ngFor="let contact of client.contacts">
                  <img alt="..." src="{{dataSharedService.getImage(contact.profile_pic)}}"
                       class="avatar avatar-sm rounded-circle me-2 cursor-pointer" *ngIf="contact.profile_pic" />
                  <div class="avatar avatar-sm rounded-circle bg-primary text-white border border-2 border-solid border-card cursor-pointer"
                       *ngIf="!contact.profile_pic">
                    {{authService.getInitials(contact.name || '')}}
                  </div>
                </ng-container>
              </div>
            </td>
            <td *ngIf="user.role_uuid === ROLES.AGENCY && active_contact == 1" class="td-actions">
              <div class="row-actions">
                <button type="button" class="icon-btn-sm info" matTooltip="Edit" [matTooltipPosition]="'left'" (click)="editClient(client)">
                  <i class="bi bi-pencil"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card-pagination" *ngIf="totalCount">
      <span class="pagination-summary">
        Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} clients
      </span>
      <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
    </div>
  </div>
</div>
